export const LOGOUT_TYPE = "LOG_OUT";

const currentUser = (state = {}, action) => {
    switch (action.type) {
        case "SET_USER":
            return {
                ...state,
                user: action.payload,
                loggedIn: true
            }
        case LOGOUT_TYPE:
            return {
                ...state,
                user: undefined,
                loggedIn: false
            }
        default:
            return state
    }
}

export default currentUser;